import React, { useEffect, useState } from 'react'
import BeeService from 'lib/api/services/bee.service'
import moment from 'moment'
import ReactAudioPlayer from 'components/AudioPlayer'
import { PhoneIncomeIcon, PhoneOutgoingIcon } from 'asterX-UI/Icons'
import ChipStandard from 'asterX-UI/DataDisplay/ChipStandard'
import StandardTable from 'asterX-UI/Table/StandardTable'
import { Grid, Link } from '@material-ui/core'
import { useWorkListViewRopStore } from 'context/WorkListViewStore/Rop/WorkListViewStore.rop'
import { NotFound } from 'components/NotFound'
import OktellService from 'lib/api/services/oktell.service'
import FieldInfo from 'asterX-UI/DataDisplay/FieldInfo'
import { GRAY_COLORS } from 'asterX-UI'

export const WorkListCalls = ({ client: { phoneNumber } }) => {
  const {
    actions: { setLoading }
  } = useWorkListViewRopStore()

  const [calls, setCalls] = useState(null)

  const columns = [
    'Дата/время',
    'Номер телефона',
    'Тип звонка',
    'Длительность',
    'Статус',
    'Запись'
  ]

  const rows = calls
    ? calls?.map((call, index) => {
        const {
          createdDate,
          calldate,
          callLink,
          link,
          duration,
          groupNumber,
          phoneNumber,
          ringDuration,
          ringDate,
          direction,
          abonentName,
          status
        } = call

        const date = ringDate
          ? moment(new Date(ringDate)).format('DD MMM YYYY HH:mm')
          : createdDate
          ? moment(new Date(createdDate)).format('DD MMM YYYY HH:mm')
          : moment(new Date(calldate)).format('DD MMM YYYY HH:mm') || '-'
        const phone = groupNumber
          ? groupNumber?.toString()?.toPhone()
          : abonentName
          ? abonentName
          : phoneNumber || '-'

        return [
          date,
          phone,
          ['income', 'in'].includes(direction) ? (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 5
              }}
            >
              <PhoneIncomeIcon /> Входяший
            </div>
          ) : (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 5
              }}
            >
              <PhoneOutgoingIcon /> Исходящий
            </div>
          ),
          ringDuration || `${duration} сек`,
          <ChipStandard>{status}</ChipStandard>,
          callLink ? (
            <ReactAudioPlayer src={callLink} controls />
          ) : link ? (
            <FieldInfo
              value={
                <Link
                  color={`${GRAY_COLORS[600]}`}
                  onClick={() => window.open(link, '_blank')}
                >
                  Прослушать звонок
                </Link>
              }
            />
          ) : (
            'Нет записи'
          )
        ]
      })
    : []

    useEffect(() => {
      if (phoneNumber) {
        setLoading(true)
        const cleanedPhoneNumber = phoneNumber.replace(/[^\d]/g, '')

        const fetchCalls = async () => {
          try {
            const [beeRes, oktellRes] = await Promise.all([
              BeeService.getListByPhone(phoneNumber),
              OktellService.getResultByPhone(cleanedPhoneNumber)
            ])

            const beeCalls = beeRes?.data || []
            const oktellCalls = oktellRes?.data || []

            const beeCallsWithLinks = await Promise.all(
              beeCalls.map(async call => {
                const { callID, status, conversationDuration } = call
                const callLink =
                  callID &&
                  !['refuse', 'cancel'].includes(status) &&
                  conversationDuration > 0
                    ? await BeeService.getCallFileByCallId(callID)
                    : null
                return { ...call, callLink: callLink?.data?.link || null }
              })
            )

            const combinedCalls = [...beeCallsWithLinks, ...oktellCalls]
            setCalls(combinedCalls)
          } catch (error) {
            console.error('Failed to fetch calls:', error)
            setCalls([])
          } finally {
            setLoading(false)
          }
        }

        fetchCalls()
      }
    }, [phoneNumber])


  return (
    <Grid container>
      {calls?.length ? (
        <StandardTable
          tableData={{
            names: columns,
            rows: rows
          }}
        />
      ) : (
        <NotFound title="Нет звонков" />
      )}
    </Grid>
  )
}
